// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"567edfb6","323":"6daa7f85","486":"53310705","698":"13f4dc59","787":"098d3fe4"}[chunkId] + ".chunk.js";
};